import React from 'react';
import { PrivacyPolicy } from '../features/privacy';

/**
 * PrivacyPage Component
 * 
 * Dedicated page component for displaying the privacy policy content.
 * This component wraps the PrivacyPolicy feature component and serves as
 * the page-level container following the pages architecture pattern.
 * 
 * This separation allows for:
 * - Better routing organization
 * - Page-specific logic if needed (analytics, SEO, etc.)
 * - Consistent page-level structure across the application
 * - Easier maintenance and feature isolation
 * 
 * @component
 * @example
 * return (
 *   <PrivacyPage />
 * )
 */
export default function PrivacyPage() {
  return (
    <>
      {/* Privacy policy content and legal information */}
      <PrivacyPolicy />
    </>
  );
}